var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.86495 20.0005C3.81909 20.0005 3.77278 19.9921 3.72859 19.9743C3.5807 19.9145 3.4987 19.7676 3.53241 19.6227L5.29421 12.0333H0.340081C0.21284 12.0333 0.0965295 11.9683 0.0380712 11.8642C-0.0203872 11.7601 -0.0109727 11.6354 0.0625175 11.5399L8.85751 0.132224C8.95074 0.0109908 9.12353 -0.032399 9.27141 0.026616C9.4193 0.0863275 9.5013 0.233233 9.46759 0.378185L7.70579 7.96756H12.6599C12.7872 7.96756 12.9035 8.03257 12.9619 8.13665C13.0204 8.24073 13.011 8.36545 12.9375 8.46101L4.14288 19.8687C4.07713 19.9536 3.97282 20.0005 3.86486 20.0005H3.86495Z",
    fill: "#6DBFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharge);
export default __webpack_public_path__ + "static/media/charge.e6ec50a24bbdeb2dc8f7bbe68f74fef0.svg";
export { ForwardRef as ReactComponent };